import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { INote } from '@interfaces/INoteData';
import {
  IDeal,
  IDiscount,
  IEnrollee,
  ILeadData,
  ITaskFull,
  PaymentResult,
} from '@interfaces/ISales';
import { IUser } from '@interfaces/IUser';
import { IAppState } from '@myStore/app.state';
import { selectTheme } from '@myStore/theme/theme.selector';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

class DialogData {
  title!: string;
  subTitle?: string;
  content!: never | null;
  formAction?: string;
  objectSet?: Set<number>;
  isEdit?: boolean;
  isESDP?: boolean;
  itemId?: number;
  teacherId?: number;
  editIdItem?: number;
  courseId?: number;
  groupNumber?: number;
  courseNumber?: number;
  notes?: INote[] | null;
  groupId?: number;
  teamId?: number;
  periodId?: number;
  currentAuthUserId?: number;
  role?: number;
  leadId?: number;
  leadData?: ILeadData;
  enrollee?: number;
  enrolleeData?: IEnrollee;
  student?: IUser;
  teachersList?: IUser[];
  type?: string;
  studentListStatus?: string;
  list?: [];
  statusId?: number;
  note?: INote;
  afterClosed?: () => void;
  beforeOpen?: () => void;
  fieldName?: string;
  fieldValue?: string;
  panelClass?: string;
  actions?: string;
  success$?: Observable<boolean>;
  disableClose?: boolean;
  loading$!: Observable<boolean>;
  saleTask?: ITaskFull;
  start_date_group?: string;
  lead?: ILeadData;
  deal?: IDeal;
  id?: number;
  groupPrice?: number;
  deals?: {
    paid?: IDeal[];
    part_paid?: IDeal[];
    dealsToClose?: number[];
  };
  isEnrollee?: boolean;
  isDeals?: boolean;
  studentPaymentNote?: PaymentResult;
  manualAdditionForm?: boolean;
  submit?: (value: { [key: string]: string | number | undefined }) => void;
  discount?: IDiscount;
  sum_discounts?: number;
  course_price?: number;
}

@Component({
  selector: 'app-dialog',
  templateUrl: './form-dialog.component.html',
  styleUrls: ['./form-dialog.component.sass'],
})
export class FormDialogComponent implements OnInit, OnDestroy {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  public theme = 'light';

  constructor(
    public dialogRef: MatDialogRef<FormDialogComponent>,
    private _store: Store<IAppState>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit() {
    this._store.pipe(select(selectTheme)).subscribe(theme => {
      this.theme = theme;
      const panelClass = this.dialogRef.componentInstance?.data.panelClass;

      if (theme === 'dark' && panelClass) {
        this.dialogRef.addPanelClass(panelClass);
      }

      if (panelClass === 'technical-work-modal') {
        this.dialogRef.addPanelClass(panelClass);
      }
    });

    if (this.data.beforeOpen) {
      this.data.beforeOpen();
    }

    this.data.success$?.pipe(takeUntil(this.destroy$)).subscribe(success => {
      if (success) {
        this.dialogRef.close();

        if (this.data.afterClosed) {
          this.data.afterClosed();
        }
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
